import { render, staticRenderFns } from "./chevron.vue?vue&type=template&id=65dcf812&"
import script from "./chevron.vue?vue&type=script&lang=js&"
export * from "./chevron.vue?vue&type=script&lang=js&"
import style0 from "./chevron.vue?vue&type=style&index=0&id=65dcf812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports